module.exports = __webpack_public_path__ + "media/images/ui__textArrowDownLight--dark-cf97d20d1d873f82259da034a094b797.png";